import { Anchor, Breadcrumbs } from '@mantine/core';
import { useEffect, useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router';
import ErrorMessage from '../../components/ErrorMessage';
import FacebookAdsDetailsForm from '../../components/Facebook/Ads/FacebookAdsDetailsForm';
import Metadata from '../../components/Metadata';
import Spinner from '../../components/Spinner';
import GuidanceModal from '../../components/UserFlows/guidanceModal';
import { Page } from '../../constants/pageTitles';
import useFetch from '../../helpers/useFetch';

const page = `${Page['facebookAds']}`;

const FacebookAdsDetailsPage = () => {
  const fetch = useFetch();
  const navigate = useNavigate();
  const location = useLocation();

  const [facebookAd, setFacebookAd] = useState();
  const [loadError, setLoadError] = useState();
  const [guidanceShow, setGuidanceShow] = useState(false);
  const [useInAutomation, setUseInAutomation] = useState(false);

  const { accountId, domainId, facebookAdId } = useParams();

  useEffect(() => {
    fetch(`/api/admin/accounts/${accountId}/domains/${domainId}/facebookAds/${facebookAdId}`)
      .then(({ facebookAd }) => {
        if (!facebookAd) {
          navigate(`/accounts/${accountId}/domains/${domainId}/facebook/ads`);
        }

        setFacebookAd(facebookAd);
      })
      .catch(setLoadError);
  }, [fetch, navigate, accountId, domainId, facebookAdId]);

  const close = (redirect) => {
    setGuidanceShow(false);
    redirect && navigate(`/accounts/${accountId}/domains/${domainId}/facebook/ads`);
  };

  const showUserFlow = () => {
    setGuidanceShow(true);
    setUseInAutomation(true);
  };

  if (loadError) {
    return <ErrorMessage message={loadError.message} />;
  }

  if (facebookAd === undefined) {
    return (
      <>
        <Spinner />
      </>
    );
  }

  const name = facebookAd?.name || 'Unknown Ad';

  const breadcrumbItems = [
    { title: 'Home', href: `#/accounts/${accountId}/domains/${domainId}/analytics` },
    { title: page, href: `#/accounts/${accountId}/domains/${domainId}/facebook/ads` },
    { title: name },
  ].map((item, index) => (
    <Anchor href={item.href} key={index}>
      {item.title}
    </Anchor>
  ));

  return (
    <>
      <Metadata title={`${page} | ${name} | Edit`} />
      <Breadcrumbs mb="md">{breadcrumbItems}</Breadcrumbs>
      <GuidanceModal
        type="Facebook Ad"
        redirect={`/accounts/${accountId}/domains/${domainId}/facebook/ads`}
        show={guidanceShow}
        elementTypes={['campaigns', 'workflows']}
        element={facebookAd}
        setShow={() => {
          setGuidanceShow(false);
          setUseInAutomation(false);
        }}
        useInAutomation={useInAutomation}
      />
      {facebookAd === null ? (
        <ErrorMessage message="Facebook Ad has been deleted." />
      ) : (
        <FacebookAdsDetailsForm
          facebookAd={facebookAd}
          onUpdate={close}
          onDelete={close}
          onDuplicate={() =>
            navigate(
              location.pathname.replace(
                `/facebook/ads/${facebookAd.id}/details`,
                `/facebook/ads/new?from=${facebookAd.id}`
              )
            )
          }
          onBack={() => navigate(-1)}
          showUserFlow={() => showUserFlow(true)}
        />
      )}
    </>
  );
};

export default FacebookAdsDetailsPage;
